module.exports = __webpack_public_path__ + "static/media/miasto_done.3cd258cd.svg";